import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DriverApiService } from 'src/app/shared/services/driver-api.service';
import { Observable } from 'rxjs/internal/Observable';
import { DocumentsApiService } from 'src/app/shared/documents-data/documents-api.service';
import { map } from 'rxjs/operators';
import * as mime from 'mime';
import { FileDataService } from 'src/app/shared/file-data/file-data.service';
import { forkJoin, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LicenseDataService {
  constructor(private readonly driverApiService: DriverApiService, private readonly fileDataService: FileDataService) {}
  uploadLicense(model: any): Observable<any> {
    return this.driverApiService.uploadLicense(model).pipe(map(response => response?.data));
  }
  updateLicense(model: any, licenseId: any): Observable<any> {
    return this.driverApiService.updateLicense(model, licenseId).pipe(map(response => response?.data));
  }
  sendImageFiles(frontLicense, backLicense, model: any): Observable<any> {
    if (model) {
      const frontLicenseUrl = model.frontScanImageUrl;
      const frontLicenseNewName = model.frontScanImageFile;
      const backLicenseUrl = model.backScanImageUrl;
      const backLicenseNewName = model.backScanImageFile;
      
      const newFrontFile = new File([frontLicense], frontLicenseNewName, { type: frontLicense.type });
      // Extract file extension from filename, not from File.type
      const frontFileExtension = frontLicenseNewName.split('.').pop()?.toLowerCase() || 'png';
      const frontFileContentType = (mime as any).getType(frontFileExtension) ?? 'image/png';
      
      const newBackFile = new File([backLicense], backLicenseNewName, { type: backLicense.type });
      // Extract file extension from filename, not from File.type
      const backFileExtension = backLicenseNewName.split('.').pop()?.toLowerCase() || 'png';
      const backFileContentType = (mime as any).getType(backFileExtension) ?? 'image/png';

      return forkJoin([
        this.fileDataService.uploadFile(newFrontFile, frontLicenseUrl, frontFileContentType),
        this.fileDataService.uploadFile(newBackFile, backLicenseUrl, backFileContentType)
      ]).pipe(map(response => response));
    }
  }
  uploadFrontLicenseImage(frontLicense: File, model: any): Observable<any> {
    if (model && frontLicense) {
      const frontLicenseUrl = model.frontScanImageUrl;
      const frontLicenseNewName = model.frontScanImageFile;
  
      const newFrontFile = new File([frontLicense], frontLicenseNewName, { type: frontLicense.type });
      // Extract file extension from filename, not from File.type
      const frontFileExtension = frontLicenseNewName.split('.').pop()?.toLowerCase() || 'png';
      const frontFileContentType = (mime as any).getType(frontFileExtension) ?? 'image/png';
  
      return this.fileDataService.uploadFile(newFrontFile, frontLicenseUrl, frontFileContentType);
    }
  
    return of(null);
  }

  uploadBackLicenseImage(backLicense: File, model: any): Observable<any> {
    if (model && backLicense) {
      const backLicenseUrl = model.backScanImageUrl;
      const backLicenseNewName = model.backScanImageFile;
  
      const newBackFile = new File([backLicense], backLicenseNewName, { type: backLicense.type });
      // Extract file extension from filename, not from File.type
      const backFileExtension = backLicenseNewName.split('.').pop()?.toLowerCase() || 'png';
      const backFileContentType = (mime as any).getType(backFileExtension) ?? 'image/png';
  
      return this.fileDataService.uploadFile(newBackFile, backLicenseUrl, backFileContentType);
    }
  
    return of(null);
  }
  
}
